<script>
    // props
    export let options;
    export let selected;
    export let id;
</script>

<select id={id} bind:value={selected}>
    {#each options as option}
        <option 
            selected={option === selected}
            value={option}
        >{option}</option>
    {/each}
</select>

<style>
    select {
        display: inline-block;
        max-width: 270px;
        min-width: 270px;
        height: 42px;
        font-size: 16px;

        color: #1AAAD0;
        border: #1AAAD0 1px solid;
        padding: 8px 32px 8px 16px;

    	appearance: none;
        box-sizing: border-box;
        background-image: linear-gradient(45deg,transparent 50%,#1AAAD0 0),linear-gradient(135deg,#1AAAD0 50%,transparent 0);
        background-position: calc(100% - 16px) calc(1em + 2px),calc(100% - 11px) calc(1em + 2px),calc(100% - 2.5em) .5em;
        background-size: 5px 5px,5px 5px,1px 1.5em;
        background-repeat: no-repeat;
    }
    @media screen and (max-width: 1198px) {
        select {
            max-width: 100%;
        }
    }
</style>